import { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { SelectNoScrollCapture as Select } from 'components/Inputs/Select';

import { SIMPLE_SUB_TYPES } from './../constants';
import { useFlashErrorDetails } from 'pages/AutomationEngine/hooks/useFlashErrorDetails';
import { useOnScreen } from '../../llm-common/useOnScreen';
import { addDeleted } from 'pages/AutomationEngine/dialogs/common';

export const BuilderTargetField = ({ data, fieldOptions, onUpdateState }) => {
  const { t } = useTranslation();

  const { targetField } = data;

  const errorDetails = useMemo(
    () => ({
      hasError: !!targetField?.deleted,
      message: t('Please select a valid variable'),
    }),
    [targetField, t]
  );

  const componentRef = useRef(null);

  const isVisible = useOnScreen(componentRef);
  const validate = useFlashErrorDetails(errorDetails, isVisible);

  const targetFieldValue = useMemo(
    () => addDeleted(targetField, t),
    [targetField, t]
  );

  return (
    <span ref={componentRef}>
      <Select
        value={targetFieldValue}
        options={fieldOptions}
        label={null}
        placeholder={t('Choose Field')}
        data-field-id="builder-target-field"
        onChange={(value) => {
          onUpdateState({
            subType: SIMPLE_SUB_TYPES.setTargetField,
            value,
          });
        }}
        validate={validate}
        error={!!targetField?.deleted}
      />
    </span>
  );
};
